import { array, object, string } from 'yup';

export default object().shape({
  type: string().required(),
  data: array().when('type', (type, schema) =>
    type === 'spreadsheet' ? schema.required() : schema.nullable(),
  ),
  existingDataset: string().when('type', (type, schema) =>
    type === 'existingDataset' ? schema.required() : schema.nullable(),
  ),
  file: string().when('type', (type, schema) =>
    type === 'file' ? schema.nullable().required() : schema.nullable(),
  ),
  reference: string().when('type', (type, schema) =>
    type === 'file' || type === 'spreadsheet' ? schema.required() : schema.nullable(),
  ),
});
